import { Injectable, Input } from '@angular/core';
import { IAttachmentRemoteRepository } from 'src/app/core/chat/repository/attachment/attachment-remote-repository';
import { HttpService } from 'src/app/services/http.service';
import { DataSourceReturn } from 'src/app/services/Repositorys/type';
import { HttpAdapter } from 'src/app/infra/http/adapter'
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AttachmentRemoteDataSourceService implements IAttachmentRemoteRepository {
  private baseUrl = `${environment.apiURLStage}chat`; // Your base URL

  constructor(
    private httpService: HttpService,
    private HttpAdapter: HttpAdapter
  ) { }

  async getAttachment(id: string | number) {
    return await this.HttpAdapter.get<Blob>(`${this.baseUrl}/attachment/${id}`, { responseType: 'blob' })
  }

}
